import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  position: relative;
  width: 100%;
`

export const GridTitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 20px;
  line-height: 30px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: uppercase;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};

  @media (max-width: ${size.tablet}) {
    font-size: 16px;
    line-height: 20px;
    margin: 20px 0 15px;
  }
`

export const ItemImageWrapper = styled.div`
  margin-bottom: 10px;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    justify-content: space-around;
  }
`

export const GridItemWrapper = styled.a`
  width: ${props => {
    return props?.itemsPerRow === 3 ? '32%' : '48%'
  }};
  margin-bottom: 15px;
  margin-right: 1.25%;

  @media (max-width: ${size.tablet}) {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`

export const GridItemDetailsWrapper = styled.div`
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  box-shadow: ${props => getShadow(props, 'sm')};
  height: 100%;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  overflow: hidden;

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    cursor: pointer;
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
    box-shadow: ${props => getShadow(props, 'md')};
    border: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }
`

export const ItemImage = styled.div`
  position: relative;
  height: 150px;
  background-image: url(${({ backgroundImage }) =>
      `"${encodeURI(backgroundImage)}"`}),
    url(${({ backgroundImage }) => `"${backgroundImage}"`});
  background-size: cover;
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  overflow: hidden;

  @media (min-width: ${size.laptop}) {
    height: 175px;
  }

  &:before {
    content: '${props => props.label_top || ''}';
    display: ${props => (props.label_top ? 'block' : 'none')};
    position: absolute;
    top: 15px;
    right: -30px;
    background-color: #6b9343;
    font-size: 18px;
    color: #fff;
    padding: 3px 40px;
    z-index: 3;
    transform: rotateY(0deg) rotate(45deg);
    font-weight: 500;
    font-family: '${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY}';
  }
`

export const TripDetailsWrapper = styled.div`
  margin-right: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-start;
  position: relative;
`

export const TripDetailsItemsWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 0px;
  padding: 10px;
  padding-top: 0px;
  display: flex;
  flex-direction: row;
  position: relative;
  text-align: left;
  flex-direction: column;
`
export const TripInfoOnImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: ${props =>
    `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY}BF`};
  padding: 5px 20px;
  padding-top: 6px;
`

export const TripInfoOnImage = styled.span`
  font-family: '${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY}';
  font-size: 15px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  margin: 0;
  line-height: 16px;
  margin-right: 3px;
`

export const TripInfoWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 10px 15px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
`
export const TripInfo = styled.div`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  padding: 0px;
  padding-top: 5px;
  margin: 0;
  line-height: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const TripInfoItem = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0px;
  margin: 0;
  line-height: 15px;
  text-transform: capitalize;
`

export const TripInfoAvailibility = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  padding: 0px;
  margin: 0;
  line-height: 15px;
  padding: 2px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
`

export const TripInfoTitle = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0px;
  margin: 0;
  padding-bottom: 5px;
  line-height: 14px;
  border-bottom: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  width: fit-content;
`

export const TitleWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: 3px;
  background-color: transparent;
  text-align: left;
  padding-bottom: 5px;
`

export const Title = styled.h6`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 15px;
  font-weight: 400;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
  margin-top: 5px;
`

export const RatingImageWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: 3px;
  background-color: transparent;
  text-align: left;
`

export const RatingImage = styled.img`
  height: 22px;
  width: auto;
`

export const CardIconsWrapper = styled.div`
  display: flex;
  width: fit-content;
  padding: 0px;
  border-radius: 3px;
  background-color: transparent;
  text-align: left;
  padding-bottom: 5px;
`
export const CardIcon = styled.div`
  right: 0px;
  display: flex;
  align-items: center;
`

export const CardIconText = styled.span`
  vertical-align: top;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 12px;
  color: #9d5c2c;
  line-height: 1.2;
  font-weight: 700;
`

export const Location = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 14px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  right: 0px;
  line-height: 1.2;
  font-weight: 700;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_LOCATION_TEXT_TRANSFORM};
`

export const Keywords = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_KEYWORDS_TEXT_TRANSFORM};
`

export const TripTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  text-decoration: none;
`

export const TripTypeOnImage = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-top-right-radius: ${props => getBorderRadius(props, 'sm')};
  border-bottom-right-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY}BF`};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 3px 20px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  position: absolute;
  left: 0px;
  top: 10px;
  text-transform: uppercase;

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  margin: 15px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`
